import * as Action from "./constants";

/**
 * Generate Coupon
 */
export function generateCoupon({ postData }) {
  return {
    type: Action.GENERATE_COUPON,
    postData,
  };
}

/**
 * Get Coupon Bundle
 */
export function getBundle({ limit }) {
  return {
    type: Action.GET_COUPON_BUNDLE,
    limit,
  };
}

/**
 * Get Coupons by Bundle ID
 */
export function getCouponsByBundleID(bundleID, exported) {
  return {
    type: Action.GET_COUPON_BY_BUNDLE,
    bundleID,
    exported,
  };
}

/**
 * Delete Bundle
 */
export function deletBundle(id) {
  return {
    type: Action.DELETE_BUNDLE,
    id,
  };
}

/**
 * Delete Coupon
 */
export function deletCoupon(id, postData) {
  return {
    type: Action.DELETE_COUPON,
    id,
    postData
  };
}

/**
 * Edit Bundle
 */
export function editBundle(id) {
  return {
    type: Action.EDIT_BUNDLE,
    id,
  };
}

/**
 * Edit Coupon
 */
export function editCoupon(id) {
  return {
    type: Action.EDIT_COUPON,
    id,
  };
}

/**
 * Update Bundle
 */
export function updateBundle({ postData }) {
  return {
    type: Action.UPDATE_BUNDLE,
    postData,
  };
}


/**
 * Update Coupon
 */
export function updateCoupon({ postData }) {
  return {
    type: Action.UPDATE_COUPON,
    postData,
  };
}

/**
 * Send Coupon Email
 */
export function sendEmail(id) {
  return {
    type: Action.COUPON_RESEND_EMAIL,
    id,
  };
}